/**
 * @generated SignedSource<<369f3309f8f6ec03427d92d39f832dab>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useDynamicSplitButton_catchupLastViewedTime$data = {
  readonly lastViewedTimeISO: string | null;
  readonly " $fragmentType": "useDynamicSplitButton_catchupLastViewedTime";
};
export type useDynamicSplitButton_catchupLastViewedTime$key = {
  readonly " $data"?: useDynamicSplitButton_catchupLastViewedTime$data;
  readonly " $fragmentSpreads": FragmentRefs<"useDynamicSplitButton_catchupLastViewedTime">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useDynamicSplitButton_catchupLastViewedTime",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "lastViewedTimeISO"
    }
  ],
  "type": "CatchupLastViewedTimeResponse"
};

(node as any).hash = "297588dba1b1d203b8ad0275eaa0e0a8";

export default node;
